import { createFileRoute, redirect } from "@tanstack/react-router";

// The standalone farm-level Registros list is gone — records live on the
// animal/herd page, and the section landing is the livestock hub. Keep the
// URL as a redirect so bookmarks and the old measurements/operations hops
// do not 404. Leave the farm-intrinsic path via `?farm=` (same as the
// `$establishmentId/` index) so path and farm scope stay in sync.
export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/livestock/$establishmentId/registries/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/app/org/$orgId/livestock",
			params: { orgId: params.orgId },
			search: { farm: params.establishmentId },
		});
	},
});
